export enum MarketplaceOpportunityStatus {
    NewOpportunity,
    Engaged,
    RejectedByBuyer,
    RejectedBySeller,
    LostOpportunity,
    Tagged,
    BuyerMissedDeadline,
    AwaitingBuyerResponse,
    AwaitingSellerResponse,
    Suspended,
    Terminated,
}

export const MarketplaceOpportunityStatusList = [
    {
        id: MarketplaceOpportunityStatus.NewOpportunity,
        name: 'New Opp',
        color: '#535bd6',
    },
    {
        id: MarketplaceOpportunityStatus.Engaged,
        name: 'Engaged',
        color: '#008000',
    },
    {
        id: MarketplaceOpportunityStatus.RejectedByBuyer,
        name: 'Rejected by Buyer',
        color: '#f30202ff',
    },
    {
        id: MarketplaceOpportunityStatus.RejectedBySeller,
        name: 'Rejected by Seller',
        color: '#f30202ff',
    },
    {
        id: MarketplaceOpportunityStatus.LostOpportunity,
        name: 'Lost Opp',
        color: '#808080',
    },
    {
        id: MarketplaceOpportunityStatus.Tagged,
        name: 'Tagged',
        color: '#8a2be2',
    },
    {
        id: MarketplaceOpportunityStatus.BuyerMissedDeadline,
        name: 'Buyer Missed Deadline',
        color: '#f30202ff',
    },
    {
        id: MarketplaceOpportunityStatus.AwaitingBuyerResponse,
        name: 'Awaiting Buyer Response',
        color: '#deb24d',
    },
    {
        id: MarketplaceOpportunityStatus.AwaitingSellerResponse,
        name: 'Awaiting Seller Response',
        color: '#008000',
    },
    {
        id: MarketplaceOpportunityStatus.Suspended,
        name: 'Suspended by Seller',
        color: '#ff6347',
    },
    {
        id: MarketplaceOpportunityStatus.Terminated,
        name: 'Sale Discontinued',
        color: '#f30202ff',
    },
];

export const MarketplaceOpportunityStatusOptions = {
    [MarketplaceOpportunityStatus.NewOpportunity]: 'New Opp',
    [MarketplaceOpportunityStatus.Engaged]: 'Engaged',
    [MarketplaceOpportunityStatus.RejectedByBuyer]: 'Rejected by Buyer',
    [MarketplaceOpportunityStatus.RejectedBySeller]: 'Rejected by Seller',
    [MarketplaceOpportunityStatus.LostOpportunity]: 'Lost Opp',
    [MarketplaceOpportunityStatus.Tagged]: 'Tagged',
    [MarketplaceOpportunityStatus.BuyerMissedDeadline]: 'Buyer Missed Deadline',
    [MarketplaceOpportunityStatus.AwaitingBuyerResponse]:
        'Awaiting Buyer Response',
    [MarketplaceOpportunityStatus.AwaitingSellerResponse]:
        'Awaiting Seller Response',
    [MarketplaceOpportunityStatus.Suspended]: 'Suspended by Seller',
    [MarketplaceOpportunityStatus.Terminated]: 'Terminated by Seller',
};
